var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kveu827oma"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.333333 0 0 0 0 0.368627 0 0 0 0 0.384314 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#kveu827oma)",
    transform: "translate(-30 -120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#828282",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.722 12.075h-.867l-.307-.296c1.075-1.251 1.723-2.876 1.723-4.643C14.271 3.195 11.077 0 7.136 0S0 3.195 0 7.136c0 3.94 3.195 7.135 7.136 7.135 1.767 0 3.392-.648 4.643-1.723l.296.307v.867l5.49 5.478 1.635-1.636-5.478-5.489zm-6.586 0c-2.734 0-4.94-2.206-4.94-4.94 0-2.733 2.206-4.94 4.94-4.94 2.733 0 4.94 2.207 4.94 4.94 0 2.734-2.207 4.94-4.94 4.94z",
    transform: "matrix(-1 0 0 1 54 120) translate(2.4 2.4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.750b6046ca3ddd78a72857a63948bde9.svg";
export { ForwardRef as ReactComponent };